'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_totp_Migration$$anon$3() {
}
export { $c_Lpresto_ui_totp_Migration$$anon$3 as $c_Lpresto_ui_totp_Migration$$anon$3 };
$p = $c_Lpresto_ui_totp_Migration$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lpresto_ui_totp_Migration$$anon$3;
/** @constructor */
function $h_Lpresto_ui_totp_Migration$$anon$3() {
}
export { $h_Lpresto_ui_totp_Migration$$anon$3 as $h_Lpresto_ui_totp_Migration$$anon$3 };
$h_Lpresto_ui_totp_Migration$$anon$3.prototype = $p;
$p.ky = (function(x) {
  if ((x !== null)) {
    var x27 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().H6(x);
    if ((!x27.k())) {
      x27.q();
      return true;
    }
  }
  return false;
});
$p.kt = (function(x, default$1) {
  if ((x !== null)) {
    var x31 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().H6(x);
    if ((!x31.k())) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__jl_Throwable__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "QR Code de exporta\u00e7\u00e3o ileg\u00edvel", x31.q()));
    }
  }
  return default$1.w(x);
});
$p.cb = (function(x) {
  return this.ky(x);
});
$p.bk = (function(x, default$1) {
  return this.kt(x, default$1);
});
var $d_Lpresto_ui_totp_Migration$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_totp_Migration$$anon$3, "presto.ui.totp.Migration$$anon$3", ({
  a4I: 1,
  a4: 1,
  t: 1,
  A: 1,
  a: 1
}));
export { $d_Lpresto_ui_totp_Migration$$anon$3 as $d_Lpresto_ui_totp_Migration$$anon$3 };
//# sourceMappingURL=presto.ui.totp.-Migration$$anon$3.js.map
